import LinkedInLogo from '../assets/images/svgs/LinkedIn.svg?react';
import BoardExLogo from '../assets/images/svgs/BoardEx.svg?react';
import CapIQ from '../assets/images/svgs/CapIQ.svg?react';
import PitchBookLogo from '../assets/images/svgs/PitchBook.svg?react';
import RRALogo from '../assets/images/svgs/RRA-logo.svg?react';
import FactivaLogo from '../assets/images/svgs/Factiva.svg?react';
import GuideStarLogo from '../assets/images/svgs/GuideStar.svg?react'
import WriterLogo from '../assets/images/svgs/Writer.svg?react'


export const APP_LOGO_MAP: {
  [key: string]: JSX.Element;
} = {
  rra_engage: <RRALogo />,
  cit: <RRALogo />,
  beacon: <RRALogo />,
  netdocs: <RRALogo />,
  boardex: <BoardExLogo />,
  capiq: <CapIQ />,
  pitchbook: <PitchBookLogo />,
  linkedin: <LinkedInLogo />,
  guidestar: <GuideStarLogo />,
  fastpath_portal: <RRALogo />,
  factiva: <FactivaLogo />,
  rra_chatgpt: <RRALogo />,
  writer: <WriterLogo />,
  lms: <RRALogo />,
  nikkei_telecom: <RRALogo />,
  bizreach: <RRALogo />,
  mergermarket: <RRALogo />,
  bciq: <RRALogo />,
  qualtrics: <RRALogo />
}